import { Navigate, Outlet, useLocation } from "react-router-dom";
import { selectCurrentUser } from "../../features/account/accountSlice";
import { useAppSelector } from "../store/configureStore";

export default function RequireAuth() {
    const user = useAppSelector(selectCurrentUser);
    const location = useLocation();

    if (!user) {
        return <Navigate to='/login' state={{ from: location }} />
    }

    return <Outlet />
}